// Can this element be scrolled to / focused, or would we send the user to a
// spot they cannot see?
//
// Deliberately structural (`hidden`, `.d-none`, an inline `display: none`)
// rather than geometric: `offsetParent` and `getClientRects()` are always empty
// under jsdom, so a layout-based check would make every element untestable and
// silently disable the guard in specs. The cases this actually has to catch —
// the contact picker's `d-none` <select>, the payment-shape item columns — are
// all class-driven anyway.
export function isReachable(element) {
  if (!element) return false
  if (element.hidden || element.type === "hidden") return false
  if (element.closest("[hidden], .d-none")) return false
  if (element.style?.display === "none") return false

  return true
}

// A field the user can actually type into once we have scrolled there.
export function isFocusable(element) {
  if (!isReachable(element)) return false

  return !element.disabled && !element.readOnly
}
